import { render, staticRenderFns } from "./UserRegister.vue?vue&type=template&id=1ffd8639"
import script from "./UserRegister.vue?vue&type=script&lang=js"
export * from "./UserRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports